/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aqua_Cute_Rat_LendInputs */

const fr_aqua_cute_rat_lend = /** @type {(inputs: Aqua_Cute_Rat_LendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de programme`)
};

/**

* @param {Aqua_Cute_Rat_LendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const aqua_cute_rat_lend = /** @type {((inputs?: Aqua_Cute_Rat_LendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aqua_Cute_Rat_LendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_aqua_cute_rat_lend(inputs)
});